"use strict";

class AuthBaseController {

    /**
     * [constructor description]
     * @param  {[type]} $http [description]
     * @return {[type]}       [description]
     */
    constructor($http, $location, bowser) {

        let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        this.$http = $http;
        this.$location = $location;
        this.submitType = 'email';

        // Defaults
        this.formdata = {
            email: null,
            password: null,
            remember: false,
            _token: csrftoken
        };

        this.status = {
            error: false,
            sending: false
        };

        if (bowser.chrome || bowser.firefox) {
            // do stuff with chrome & firefox
            this.browserCheck = false;
        } else {
            this.browserCheck = true;
        }
    }

    /**
     * [submit description]
     * @param  {Boolean} isValid [description]
     * @return {[type]}          [description]
     */
    submit(isValid) {

        if (!isValid) {
            return;
        }

        if (this.submitType === 'email') {
            this.submitEmail();
        } else {
            this.submitPassword();
        }

    }

    submitEmail() {
        this.status.sending = true;
        this.status.error = false;

        this.$http.post('/auth/login', this.formdata).then(response => {
            let data = response.data;
            if (data.method === 'adfs') {
                this.$http.get('/login/adfs').then((response) => {
                    window.location.href = response.data;
                });
            } else if (data.method === 'azure') {
                this.$http.get('/login/azure').then((response) => {
                    window.location.href = response.data;
                });
            } else {
                this.submitType = 'password';
                document.getElementById('password-field-input').focus();
            }
        }).catch(() => {
            this.status.error = true;
            this.status.sending = false;
        });
    }

    submitPassword() {
        this.status.sending = true;
        this.status.error = false;

        this.$http.post('/auth/login/password', this.formdata).then(() => {
            // Login successfull!
            this.status.sending = false;
            window.location.reload();
        }).catch(() => {
            this.status.error = true;
            this.status.sending = false;
        });
    }
}

AuthBaseController.$inject = ['$http', '$location', 'bowser'];

module.exports = AuthBaseController;

